export default {"src":"/_next/static/media/closeUiRed_16.d450da90.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};